import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { storeToRefs } from 'pinia';
import BaseContainer from '~/core/components/Base/BaseContainer.vue';
import PersonalDataCheckbox from '~/core/components/RulesAgree/components/PersonalDataCheckbox.vue';
import useMainStore from '~/stores/useMainStore';
import useProfileStore from '~/stores/useProfileStore';
import useLocaleStore from '~/stores/useLocaleStore';
import useCountriesStore from '~/stores/useCountriesStore';
import { AgreementStatus } from '~/features/Profile/enums';
export default defineComponent({
  name: 'RulesAgree',
  components: {
    PersonalDataCheckbox: PersonalDataCheckbox,
    BaseContainer: BaseContainer
  },
  setup: function setup() {
    var mainStore = useMainStore();
    var _storeToRefs = storeToRefs(mainStore),
      isLayoutError = _storeToRefs.isLayoutError;
    var profileStore = useProfileStore();
    var _storeToRefs2 = storeToRefs(profileStore),
      agreementStatus = _storeToRefs2.agreementStatus,
      preventShowingAgreement = _storeToRefs2.preventShowingAgreement,
      afterAgreementCallback = _storeToRefs2.afterAgreementCallback;
    var locale = useLocaleStore();
    var countries = useCountriesStore();
    var _storeToRefs3 = storeToRefs(locale),
      landingUrl = _storeToRefs3.landingUrl,
      personalDataAgreementLink = _storeToRefs3.personalDataAgreementLink;
    var isRulesAgreementCheckboxChecked = ref(true);
    var _useNuxtApp = useNuxtApp(),
      $captureException = _useNuxtApp.$captureException;
    var doesCountryRequireConsent = computed(function () {
      return !!personalDataAgreementLink.value;
    });
    var isReAgreement = computed(function () {
      return agreementStatus.value === AgreementStatus.ReAgreement;
    });
    var shouldShowRulesAgreement = computed(function () {
      return !preventShowingAgreement.value && !isLayoutError.value && [AgreementStatus.Never, AgreementStatus.ReAgreement].includes(agreementStatus.value);
    });
    function handleAgreeClick() {
      return _handleAgreeClick.apply(this, arguments);
    }
    function _handleAgreeClick() {
      _handleAgreeClick = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (afterAgreementCallback.value) {
                afterAgreementCallback.value();
              }
              _context2.next = 4;
              return profileStore.rulesAgree();
            case 4:
              _context2.next = 9;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              $captureException(_context2.t0, {
                component: 'RulesAgree',
                method: 'handleAgreeClick'
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 6]]);
      }));
      return _handleAgreeClick.apply(this, arguments);
    }
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return countries.fetchCountries();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return {
      landingUrl: landingUrl,
      isRulesAgreementCheckboxChecked: isRulesAgreementCheckboxChecked,
      isReAgreement: isReAgreement,
      shouldShowRulesAgreement: shouldShowRulesAgreement,
      doesCountryRequireConsent: doesCountryRequireConsent,
      handleAgreeClick: handleAgreeClick
    };
  }
});